import * as Factory from 'factory.ts'

import { FEATURE_SWITCH_DEFAULTS } from '../../core/stores/global'
import { type FeatureSwitches } from '../../models/FeatureSwitch'

export const FeatureSwitchesFactory = Factory.makeFactory<FeatureSwitches>({
  ...FEATURE_SWITCH_DEFAULTS,
})
